import {clientLog} from "../clientLog";

/**
 * Remembers in this browser when the user chose "Ikke nå" for installing DAMS (DE-1707).
 *
 * Storage may be unavailable (private mode, blocked site data); then the dismissal
 * is simply not remembered and the banner may show again.
 */

/** The localStorage key holding the dismissal time, in ms since the epoch. */
export const DISMISSAL_KEY = 'dams.installApp.dismissedAt';

const COMPONENT = 'installDismissal';

/**
 * @param {function(): Storage} [getStorage]  Returns the storage to use.
 * @returns {{read: function(): (number|null), write: function(number): void}}
 */
export const createInstallDismissal = (getStorage = () => window.localStorage) => ({
    read: () => {
        try {
            return parseTime(getStorage().getItem(DISMISSAL_KEY));
        } catch (error) {
            logStorageError('read', error);
            return null;
        }
    },
    write: (time) => {
        try {
            getStorage().setItem(DISMISSAL_KEY, String(time));
        } catch (error) {
            logStorageError('write', error);
        }
    },
});

const parseTime = (value) => {
    if (!/^\d+$/.test(value ?? '')) {
        return null;
    }
    return Number(value);
};

const logStorageError = (action, error) =>
    clientLog('warn', `could not ${action} the install dismissal: ${error.name}`, COMPONENT);
